/**
 * Admin Level Table Component
 *
 * Displays a table of admin levels using DataTable.
 */

import * as React from "react";
import { type SortingState } from "@tanstack/react-table";
import { DataTable } from "@/components/ui/data-table";
import { Shield } from "lucide-react";
import type { AdminLevelItem } from "@/services/adminService";
import { createAdminLevelColumns } from "../columns/adminLevelColumns";

interface AdminLevelTableProps {
  adminLevels: AdminLevelItem[];
  loading: boolean;
  onEdit: (adminLevel: AdminLevelItem) => void;
  onDelete: (adminLevel: AdminLevelItem) => void;
}

export function AdminLevelTable({ adminLevels, loading, onEdit, onDelete }: AdminLevelTableProps) {
  const [sorting, setSorting] = React.useState<SortingState>([
    { id: "order", desc: false },
  ]);

  const columns = React.useMemo(
    () => createAdminLevelColumns({ onEdit, onDelete }),
    [onEdit, onDelete]
  );

  return (
    <DataTable
      columns={columns}
      data={adminLevels}
      loading={loading}
      emptyMessage="Tidak ada admin level"
      emptyIcon={<Shield className="h-12 w-12 mx-auto text-muted-foreground mb-4" />}
      manualSorting={false}
      sorting={sorting}
      onSortingChange={setSorting}
      showColumnToggle={false}
    />
  );
}
